import apiClient from './apiClient';

// -- TypeScript Interfaces (aligned with backend modules/p9315/models/p9315.go JSON tags) --

/** Query parameters for the Department Personal Attendance Time report. */
export interface QueryParams {
  year: number;       // PR_POST_YY - attendance year
  month: number;      // PR_POST_MM - attendance month (1-12)
  deptFrom?: string;  // L_START_DEPT - department code range start
  deptTo?: string;    // L_LAST_DEPT - department code range end
}

/** A single day's attendance hours for one employee. */
export interface DailyHours {
  day: number;    // 1-31
  hours: number;  // attendance hours for that day
}

/** One row in the report result - one employee's monthly attendance (= one PF910 cursor row). */
export interface AttendanceRow {
  F910_01: string;        // employee number
  F910_18: string;        // department code
  F910_31: number;        // monthly total hours
  F910_32: number;        // attendance days count
  dailyHours: DailyHours[]; // F910_201~F910_231 per-day hours
  F901_11: string;        // employee name (from F901 join)
  dept_name: string;      // department name (from F106 lookup)
}

/** Full API response for the attendance time report query. */
export interface QueryResponse {
  data: AttendanceRow[];
  count: number;
  year: number;
  month: number;
  daysInMonth: number;
  message?: string;
}

// -- API Client --

export const p9315Api = {
  /** POST /api/p9315/query - Query department personal attendance time by year/month + dept range */
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/p9315/query', params);
    return res.data;
  },

  /** GET /api/p9315/lookup/:type/:code - Lookup name by type (department | employee) & code */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/p9315/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
